// extracted by mini-css-extract-plugin
export default {"context":"burger-context-menu_context__wdjjI","burger":"burger-context-menu_burger__a06vB"};